export default class RequeueModalController {
  constructor(Technology, Task) {
    'ngInject';

    this.Task = Task;
    this.Technology = Technology;
  }

  $onInit() {
    this.technologies = [];
    this.sub_technologies = [];

    this.loadTechnologies().then(this.loadSubTechnologies.bind(this));
  }

  loadTechnologies() {
    return this.Technology.query().$promise
      .then((response) => {
        this.technologies = response.technologies;

        return this.task.technology_id;
      })
  }

  loadSubTechnologies(technologyId) {
    this.sub_technologies = [];

    return this.Technology.subTechnologies({ technologyId }).$promise
      .then((response) => {
        this.sub_technologies = response.sub_technologies;
      })
      .catch(() => {
        this.sub_technologies = [];
      })
  }

  handleRequeue(task) {
    return this.Task.requeue({}, task).$promise
      .then((response) => {
        this.onActionSubmit({task: response.task});
        this.closeModal();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/screens/task-detail/components/requeue-modal/requeue-modal.controller.js